var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentStatusUnderMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "120 0 780 920",
    focusable: "false",
    role: "presentation",
    transform: "rotate(-90)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 459.52c0 212.077 171.923 384 384 384s384-171.923 384-384c0-212.077-171.923-384-384-384v0c-212.077 0-384 171.923-384 384v0zM313.173 331.52c7.753 7.924 18.556 12.837 30.507 12.837s22.753-4.913 30.499-12.83l0.008-0.008c7.924-7.753 12.837-18.556 12.837-30.507s-4.913-22.753-12.83-30.499l-0.008-0.008c-7.807-7.807-18.593-12.636-30.507-12.636-23.827 0-43.143 19.316-43.143 43.143 0 11.914 4.829 22.699 12.636 30.507v0zM599.467 462.933c6.966-1.515 14.969-2.382 23.174-2.382 62.916 0 113.92 51.004 113.92 113.92 0 17.932-4.143 34.897-11.525 49.988l0.297-0.673-90.453-90.453-55.893 56.32 90.027 90.027c-14.862 7.568-32.412 12.002-50.997 12.002-63.152 0-114.347-51.195-114.347-114.347 0-8.176 0.858-16.152 2.489-23.842l-0.133 0.747-216.32-215.893c-8.651-10.4-13.902-23.895-13.902-38.617 0-18.757 8.524-35.523 21.909-46.636l0.1-0.080c10.632-13.793 27.159-22.592 45.74-22.592 15.348 0 29.295 6.003 39.619 15.789l-0.026-0.024z",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentStatusUnderMaintenance);
export default __webpack_public_path__ + "static/media/component_status_under_maintenance.09f758a152268f5fbf46a3ee3c0eb32f.svg";
export { ForwardRef as ReactComponent };